import ConfigForm from './ConfigForm.jsx';

export default function HiddenConfig({ field, onConfigChange }) {
  return <ConfigForm schema={[]} config={field.config} onConfigChange={onConfigChange} />;
}
